import React from "react";
import { INDUSTRY, AUDITS } from "../../../core/theme/auditsTheme";
import WebsiteMatches from "./WebsiteMatches";

// Bottom right: the stage 1 website search, across the whole account. A
// match opens Advertiser Snapshot with that website pinned. Monitored
// advertisers come in B2 stage 5.
//   website: useWebsiteSearch's { domain, searching, jobIds } for text
export default function AdvertisersPanel({ jobs, text, setText, website, onOpenPinned }) {
  const typed = text.trim();

  return (
    <section aria-label="Advertisers" className={`${INDUSTRY.panel} ${INDUSTRY.advertisers}`}>
      <h2 className={INDUSTRY.label}>Advertisers</h2>
      <p className={INDUSTRY.note}>Search any advertiser seen in your Snapshots.</p>
      <input
        className={AUDITS.search} value={text} onChange={e => setText(e.target.value)}
        placeholder="Search by advertiser website, for example acme.co.uk" aria-label="Search advertisers by website"
      />
      {website.domain ? (
        <WebsiteMatches jobs={jobs} website={website} onOpenPinned={onOpenPinned} />
      ) : typed ? (
        <p className={INDUSTRY.note}>Type a whole website, for example acme.co.uk.</p>
      ) : null}
    </section>
  );
}
